import { getMe } from 'platform-components/src/components/user/selectors';
import { InjectedProps as WithRouterPathHOC, withRouterPath } from 'platform-components/hocs';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import copyLessonModalActions from 'common.components/copy-lesson-modal/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { LessonStore } from 'common.components/lesson/typings';

import { LessonViewInformationBanners } from './lesson-view__information-banners';

interface HOCProps extends WithRouterPathHOC, WrappedComponentProps {}

const mapStateToProps = <T extends LessonStore>(storeState: T, ownProps: HOCProps) => {
    const {
        intl,
        match: { params },
        location: { search },
    } = ownProps;
    const { classId, subject } = params || {};
    const certificateSlug = intl.formatMessage({ id: 'lesson.informationBanner.certificate.slug' });
    const certificate = lessonSelectors.getLessonCertificateBySlug(storeState, { certificateSlug });

    const feedbackUrl = lessonSelectors.getLessonFeedbackUrl(storeState, { intl });
    const shouldShowFeedbackBanner = lessonSelectors.getShouldShowFeedbackBanner(storeState, { intl });
    // @ts-ignore не понимает что нужен classId
    const shouldShowRNOBanner = lessonSelectors.getShouldShowRNOBanner(storeState, { classId, subject, search });
    const lessonTitle = lessonSelectors.getName(storeState) || '';

    return {
        certificate,
        clessonId: lessonSelectors.getCLessonId(storeState),
        feedbackUrl,
        lessonTitle,
        shouldShowFeedbackBanner,
        shouldShowRNOBanner,
        teacherId: getMe(storeState)?.id || null,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    const { copyLessonAsRNO } = copyLessonModalActions;

    return bindActionCreators({ copyLessonAsRNO }, dispatch);
};

export const LessonViewInformationBannersContainer = injectIntl(
    withRouterPath(connect(mapStateToProps, mapDispatchToProps)(LessonViewInformationBanners))
);
